import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pop-up-message-wrapper"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { class: "description-wrapper" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "wks-open-input-wrapper" }

import { ref, onBeforeMount, onUnmounted, watch, toRefs } from 'vue'
import { IonContent, IonPage, alertController, toastController } from "@ionic/vue";
import PopUpMask from '@/modules/a.worksheets/views/components/feedback/PopUpMask.vue'
import { getComputedPageLayout } from '@/helpers/api';
import { getIcon } from '@/helpers/api';
import { SolutionData, useWorksheetHandler } from '@/globals/helpers/worksheetHandler';
import { worksheetService } from '@/modules/a.worksheets/services/worksheet.service';
import { Wks_Modals, useModalManager } from '@/modules/a.worksheets/services/modalManager';
import WksOpenInput from "@/modules/a.worksheets/views/components/footer/WksOpenInput.vue";
import { useOpenInput } from '@/modules/a.worksheets/helpers/wksOpenInput';
import { spinnerManager } from '@/globals/pages/spinnerControl';
import WksOpenInputOneFile from '@/modules/a.worksheets/views/components/footer/WksOpenInputOneFile.vue'
import { useDeviceStatus } from '@/stores/deviceStatus';

interface _1615A {
    labels: {
        title: string,
        lines: Array<string>,
    },
    helps: {
        msg: string,
    },
    errors: {
        maxSizeMBytes: string,
        maxDuration: string
    },
    commands: {
        audio: boolean,
        document: boolean,
        photo: boolean,
        video: boolean,
        pdf: boolean,
        text: boolean,
        maxNumFiles: number,
        maxSizeMBytes: number,
        maxDuration: number
    }
}

interface MediaPayload {
  text: string;
  files: File[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FoundErrorModal',
  setup(__props) {

const mediaButton = ref<Array<any>>([])
const { updateMediaButtons, getMediaButtons, textBtn } = useOpenInput();

const { isWeb } = toRefs(useDeviceStatus());


const layout = getComputedPageLayout<_1615A>('1615A')
const icon = ref<string>()
onBeforeMount(async () => {
    icon.value = await getIcon('1615A', 'icon')
    await updateMediaButtons();
})

async function createBtn(type: 'audio' | 'document' | 'photo' | 'video' | 'expand' | 'pdf', isEnabled: boolean | undefined): Promise<undefined | any> {
  if (isEnabled) {
    const resolvedSrc = await getIcon("1602", type)
    return {
      src: resolvedSrc ?? '',
      route: btnRoutes[type],
      name: type === 'expand' ? 'text' : type
    }
  }
}

const btnRoutes = {
  photo: 'worksheet-take-photos',
  video: 'worksheet-take-videos',
  audio: 'worksheet-take-audios',
  document: 'worksheet-upload-document',
  pdf: 'worksheet-upload-pdf',
  expand: 'text-editor',
}

const wh = useWorksheetHandler()
async function catchMedia(payload: MediaPayload, type: SolutionData): Promise<void> {
    try {
        const activityUUID = wh.$.activity.uuid.value;

        if (!activityUUID) {
            console.warn('Activity UUID não encontrado.');
            return;
        }

        if (payload.files.length > 0 && layout.value) {    
            const file = payload.files[0];

            const maxSizeBytes = layout.value.commands.maxSizeMBytes * 1024 * 1024;
            if (isGreaterThen(file, maxSizeBytes)) {
                const toast = await toastController.create({
                    message: layout.value.errors.maxSizeMBytes + layout.value.commands.maxSizeMBytes,
                    duration: 2500,
                    position: "top"
                })
                toast.present();
                return;
            }

            if (file.type.includes('audio') && await greaterDuration(file, layout.value.commands.maxDuration)) {
                const toast = await toastController.create({
                    message: layout.value.errors.maxDuration + layout.value.commands.maxDuration,
                    duration: 2500,
                    position: "top"
                })
                toast.present()
                return;
            }
        }


        spinnerManager.registerTask("sending feedback");
        await sendFeedback(wh.wksUUID.value, activityUUID, payload, type);
        spinnerManager.unregisterTask("sending feedback");


    } catch (error) {
        console.error('Erro ao processar o media:', error);
        spinnerManager.unregisterTask("sending feedback");
    }
}

function isGreaterThen(file: File, size: number): boolean {
    if(file.size > size){
        return true
    }else{
        return false
    }
}
async function greaterDuration(file: File, maxDuration: number): Promise<boolean> {
    const duration = await getAudioDuration(URL.createObjectURL(file))
    if(duration > maxDuration){
        return true
    }else{
        return false
    }
}

async function getAudioDuration(url: string): Promise<number> {
    return await new Promise<number>((resolve, reject) => {
      const audio = new Audio(url);
      // Set the preload attribute to 'metadata'
      audio.preload = "metadata";

      // Attach the loadedmetadata event listener
      audio.addEventListener("loadedmetadata", () => {
        resolve(audio.duration);
      });

      audio.addEventListener("error", () => {
        reject(new Error("Failed to load audio metadata"));
      });
    });
  }

const modalManager = useModalManager()
async function sendFeedback(
  user_wks_status: string,
  activity_uuid: string,
  payload: MediaPayload,
  type: SolutionData
): Promise<void> {
  try {
    spinnerManager.registerTask("sendFeedback");
    const msg = payload.text.trim();
    const files = payload.files;

    const response = await worksheetService.postFoundError(user_wks_status, activity_uuid, msg, files);

    if (response.status === 200) {
      modalManager.open(Wks_Modals.PROBLEM_ERROR_FOUND_THANKS);
    } else {
      console.error('Erro ao enviar feedback:', response.statusText);
    }
  } catch (error) {
    console.error('Erro inesperado ao enviar feedback:', error);
  } finally {
    spinnerManager.unregisterTask("sendFeedback");
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          (_unref(layout))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(PopUpMask, null, {
                  icon: _withCtx(() => [
                    _createElementVNode("img", { src: icon.value }, null, 8, _hoisted_2)
                  ]),
                  title: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(layout).labels.title), 1)
                  ]),
                  description: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout).labels.lines, (line, key) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: key,
                          innerHTML: line
                        }, null, 8, _hoisted_5))
                      }), 128))
                    ])
                  ]),
                  button: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(WksOpenInputOneFile, {
                        "media-button": _unref(getMediaButtons),
                        placeholder: _unref(layout).helps.msg,
                        onSetMedia: catchMedia
                      }, null, 8, ["media-button", "placeholder"])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})